import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './LegendEntry.module.css';

const cx = classnames.bind(styles);

LegendEntry.propTypes = {
  color: PropTypes.string,
};

/**
 * **Access:**
 * ```js
 * import {LegendEntry} from '@iss/client-react-components'
 * ```
 * Provides a Legend element.
 *
 * @class LegendEntry
 * @component
 */
export default function LegendEntry({ color, direction, stroke, icon, children, ...props }) {
  if (!icon) {
    icon = (
      <svg viewBox="0 0 15 15" width="15" height="15">
        <rect fill={color} stroke={stroke} width="15" x="0" y="0" height="15" rx="15" />
      </svg>
    );
  }

  return (
    <span
      className={cx('legend-entry', direction === 'horizontal' ? 'legend-horizontal' : 'legend-vertical')}
      {...props}
    >
      {icon}
      {children}
    </span>
  );
}
